import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "812eae16-b579-4b36-82fb-7726b842d2d8",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/04/28/task/task-3-answer-a.svg` },
  },
  {
    id: "6f7b64b3-6e9c-496d-ab7a-dbd9b9690fcb",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/04/28/task/task-3-answer-b.svg` },
  },
  {
    id: "d4b463b6-4e56-4364-8ee8-95f9da789a78",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/04/28/task/task-3-answer-c.svg` },
  },
  {
    id: "147f365a-7080-4f6e-bb9a-2a7ce77a500f",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/04/28/task/task-3-answer-d.svg` },
  },
];

export const task: Task = {
  id: "cfa27042-a831-4b9d-a9b1-16e31f41f2ca",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["147f365a-7080-4f6e-bb9a-2a7ce77a500f"],
};
